import * as React from "react";
// import { Checkbox, FormControlLabel } from "@mui/material";
// import { pink } from "@mui/material/colors";
// import { useState, useRef } from "react";
// import { upload } from '@testing-library/user-event/dist/upload';
// import DeliveryInformation from "./DeliveryInformation";
import AddAttestationService from "./AddAttestationService";
import Payment from "./Payment";
import MyRequest from "./MyRequest";
// import Login from "./AttestationLoginForm";
import RegistrationForm from "./RegistrationForm";
import AttestationLoginForm from "./AttestationLoginForm";
import ShipperInformation from "./ShipperInformation";

const NRPLogin = () => {
  // STEPPER
  // const [activeStepper, setActiveStepper] = useState(0);

  // const refs = [useRef(), useRef(), useRef(), useRef()];

  // const handleNext = () => {
  //   setActiveStepper((prevActiveStep) => prevActiveStep + 1);
  //   const activeRef = refs[activeStepper];
  //   activeRef.current.display = "flex";
  //   refs.forEach((ref, index) => {
  //     if (index !== activeStepper) {
  //       ref.current.display = "none";
  //     }
  //   });
  // };
  // const handleBack = () => {
  //   setActiveStepper((prevActiveStep) => prevActiveStep - 1);
  //   const activeRef = refs[activeStepper];
  //   activeRef.current.display = "flex";
  //   refs.forEach((ref, index) => {
  //     if (index !== activeStepper) {
  //       ref.current.display = "none";
  //     }
  //   });
  // };

  // const previousSlider = () => {
  // no of slide = current - 1
  // }
  // const NextSlider = () => {
  // current + 1
  // }
  // const steps = getSteps();

  // const [page, setPage] = useState(0);
  // const FormTitles = ["Booking", "Booking", "Booking","Payment"];
  // const pageDisplay = () => {
  //   if(page === 0){
  //     return <ShipperInformation/>;
  //   } else if(page ===1){
  //     return<DeliveryInformation/>
  //   }else if(page ===2){
  //     return <AddAttestationService/>
  //   }else if(page === 3){
  //     return <Payment/>
  //   }
  // }

  return (
    <>
      {/* NRP LOGIN */}
      <AttestationLoginForm></AttestationLoginForm>
      {/* NRP LOGIN */}

      {/* MY REQUEST */}
      <MyRequest></MyRequest>

      {/* MY REQUEST */}
      {/* Booking */}

      <div className="outer-wrapper">
        <div className="inner-wrapper  items-center">
          <div className="bg-[#efefef] flex flex-col justify-center items-center min-h-[180px] py-[2rem] ">
            <h1 className="text-[30px] sm:text-[40px] font-bold ">Booking</h1>
          </div>
        </div>
      </div>

      {/* STEPPER */}

      {/* Shipper Information */}
      <ShipperInformation></ShipperInformation>
      {/* Shipper Information */}
      {/* STEPPER */}

      {/* DELIVERY INFORMATION */}

      {/* DELIVERY INFORMATION */}
      <AddAttestationService></AddAttestationService>
      {/* ADD ATTESTATION SERVICES */}

      {/* ADD ATTESTATION SERVICES */}

      {/* PAYMENT */}
      <Payment></Payment>

      {/* PAYMENT */}

      {/* REGISTERATION FORM */}
      <RegistrationForm></RegistrationForm>
      {/* REGISTERATION FORM */}
    </>
  );
};
export default NRPLogin;
